import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { FileCsvIcon } from '@phosphor-icons/react';
import {
  Route as pathlessAuthenticatedRoute,
  requireAnyPermission,
  requireModules,
} from '../../route';
import { ResultsToUploadPage } from './ResultsToUploadPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/pricing/results-to-upload',
  staticData: {
    app: {
      nav: {
        label: msg('Results → Upload', {
          context: 'sidebar nav label, Pricing section',
        }),
        icon: <FileCsvIcon className="h-4 w-4" weight="fill" />,
        group: 'Pricing',
        order: 50,
        groupOrder: 35,
      },
      access: {
        modulesAnyOf: [ProductModule.PRICING],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Pricing }],
      },
    },
  },
  component: ResultsToUploadPage,
  loader: () => ({
    crumb: msg('Results → Upload', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PRICING],
    });
    // `access` above only decides what the sidebar shows; direct navigation
    // needs its own guard.
    await requireAnyPermission({
      context,
      permissions: [{ action: Action.Read, subject: Subject.Pricing }],
    });
  },
});
